export const underlineThatGrowsOnHover = css`
  display: inline-flex;
  position: relative;
  z-index: 0;
  line-height: ${p => p.theme.lh2};

  /* Reset default link/button styles */
  border: none;
  background: transparent;
  text-decoration: none;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: -0.1em;
    left: 0;
    z-index: -1;
    background-color: ${p => p.theme.orange};
    width: 4rem;
    max-width: 100%;
    height: 0.3em;
    transform-origin: bottom;
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    &:after {
      height: 0.75em;
    }
  }
`

///////////////////////////////////////////////////////////////////////////////////

import { css } from 'styled-components'
